/**
 * Test IDs for QA automation.
 */
export const testIds = {
  orgMaintenanceTaskFormLabel: "org-maintenance-task-form-label",
  orgMaintenanceTaskFormAlertBeforeDays: "org-maintenance-task-form-alert-before-days",
  orgMaintenanceTaskFormEvery: "org-maintenance-task-form-every",
  orgMaintenanceTaskFormSave: "org-maintenance-task-form-save",
} as const;
